import { postPaymentEvergreen } from "@api/index";
import { updateStep1ToDefault } from "@redux/slices/EVER_GREEN/step1Slice";
import { updateStep2ToDefault } from "@redux/slices/EVER_GREEN/step2Slice";
import { updateStep3ToDefault } from "@redux/slices/EVER_GREEN/step3Slice";
import {
  IInitialStatePaymentFormData,
  updatePaymentRef,
  updateStep4ToDefault,
} from "@redux/slices/EVER_GREEN/step4Slice";
import { store } from "@redux/store";
import { PLANS_NAME } from "@static/config";
import { IContentData } from "@static/content";
import { ROUTE_PATH } from "@static/route-paths";
import { LoadingScreen } from "@utils/helpers";
import { IEvergreenPaymentPayload } from "@utils/interfaces";
import { trackOnFormStartOrSuccess, trackOnLoad } from "./analyticsHelper";

export function isNonIncomerGroup(input: string) {
  return ["A217", "A342", "A398", "A375", "A215"].includes(input);
}
export function format(amount: number, flag = false) {
  if (amount <= 999 && !flag) {
    return amount.toString().replace(",", "");
  }
  //Convt number to string
  const amountString = amount.toString().split("");
  //check the len of string and add comma after every three digit from right end side
  const len = Math.floor(amountString.length / 3);
  //iterate through amount and add comma
  for (let i = 1; i <= len; i++) {
    let calc = -3 * i - (i - 1);
    if (calc <= -amountString.length) break;
    amountString.splice(-3 * i - (i - 1), 0, ",");
  }
  if (flag) {
    return amountString.join("");
  }
  return amountString.join("").concat(".00");
}

export function clearEverGreenStore() {
  store.dispatch(updateStep1ToDefault(""));
  store.dispatch(updateStep2ToDefault(""));
  store.dispatch(updateStep3ToDefault(""));
  store.dispatch(updateStep4ToDefault(""));
}

export function updateHeaderContent(
  content: IContentData,
  currentPolicy: string
) {
  if (currentPolicy === PLANS_NAME.EVER_GREEN) {
    if (content?.features?.length > 0 && content?.features[0]) {
      let { interestRate } = store.getState().everGreenStep1.staticData;
      if (!interestRate) {
        const policyData = JSON.parse(
          sessionStorage.getItem("policyConfirmation")!
        );
        if (policyData) {
          interestRate = policyData?.staticData;
        }
      }
      if (interestRate) {
        content.features[0] = `Guaranteed yield of ${interestRate}% per annum^`;
        // -------------------
        content.disclaimer = `^The guaranteed yield of ${interestRate}% per annum upon maturity is based on the Life Assured surviving until the end of the policy term with no surrender or claims made during the entire policy term.`;
      }
    }
  }
}

export async function interbankSRSPayment(
  formData: IInitialStatePaymentFormData,
  history: { push: (arg0: string) => void },
  customerId: number | null | undefined,
  transactionId: string,
  trackingCodeJson: any
) {
  const dispatch = store.dispatch;
  const bankDetails = {
    bankId: "",
    chequeNo: "",
    issueBank: "",
    paymentType: "",
  };
  let thirdParty: any = {
    fullName: "",
    nricFinPassportNo: "",
    policyReason: "",
    relationshipStatus: "",
  };
  if (formData.paymentMethod === "srs") {
    bankDetails.bankId = formData.srsForm.operator.id;
    bankDetails.chequeNo = formData.srsForm.accountNum;
    bankDetails.issueBank = formData.srsForm.operator.label;
    bankDetails.paymentType = "SRS";
  } else {
    bankDetails.paymentType = "Cash";
    bankDetails.bankId = "11";
    // ------------------------
    bankDetails.chequeNo = "";
    bankDetails.issueBank = "";
  }

  //&& formData.paymentMethod === "interbank"

  if (formData.interbankFastForm.isPayingSelf === "NO") {
    thirdParty.fullName = formData.interbankFastForm.name;
    thirdParty.nricFinPassportNo = formData.interbankFastForm.nric;
    thirdParty.policyReason = formData.interbankFastForm.reason;
    thirdParty.relationshipStatus = formData.interbankFastForm.relationship;
  } else {
    thirdParty = null;
  }
  const payload: IEvergreenPaymentPayload = {
    customerId: Number(customerId),
    transactionId,
    trackingCodeJson,
    paymentMethod: {
      bankDetails,
      payingYourself:
        formData.interbankFastForm.isPayingSelf === "YES" ? "Y" : "N",
      thirdParty,
    },
  };

  try {
    //TODO: revisit the payment flow as paynow and fast may require long polling.
    LoadingScreen();
    const { data } = await postPaymentEvergreen(payload);
    trackOnFormStartOrSuccess("DS_payment_option_form", true);

    dispatch(
      updatePaymentRef({
        paymentRef: data?.paymentRef,
        policyNumber: data?.policyNumber,
        trancheStatus: data?.trancheStatus,
      })
    );
    if (data?.trancheStatus?.toLowerCase() === "exceeded") {
      return;
    }
    history.push(ROUTE_PATH.EVER_GREEN_THANK_YOU);
  } catch (e) {
    trackOnLoad({
      errorPage: { errorCode: "500", errorMsg: "Trenches limit api failed" },
    });
    history.push(ROUTE_PATH.EVER_GREEN_CONTACTUS);
  } finally {
    LoadingScreen(false);
  }
}
